import React, { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import SidebarActionButton from 'UI/components/molecules/SidebarActionButton';

import { useStyles } from './styles';

/**
 * @param {Object} props
 * @param {string} [props.className]
 * @param {React.ElementType} props.icon
 * @param {number} props.iconSize
 * @param {Array<MenuButtonItemsProps>} props.menuItems
 * @param {string} props.text
 */
const CollapsableButtonMenu = ({ className, icon, iconSize, menuItems, text }) => {
  const history = useHistory();
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleToggle = () => setIsOpen(prevOpen => !prevOpen);

  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) return;

    setIsOpen(false);
  };

  const handleClick = (e, menu) => {
    handleClose(e);
    menu.link && history.push(menu.link);
  };

  return (
    <>
      <SidebarActionButton
        ref={anchorRef}
        aria-controls={isOpen ? 'menu-list-grow' : undefined}
        aria-haspopup="true"
        className={className}
        icon={icon}
        iconSize={iconSize}
        onClick={handleToggle}
        text={text}
      />
      <Popper
        anchorEl={anchorRef.current}
        className={classes.menuPopper}
        disablePortal
        open={isOpen}
        placement="right-start"
        role={undefined}
        transition
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps} style={{ transformOrigin: 'left top' }}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList autoFocusItem={isOpen} id="menu-list-grow">
                  {menuItems &&
                    menuItems.map(menu => {
                      const Icon = menu?.icon;
                      return (
                        <MenuItem
                          key={menu.link}
                          className={classes.menuItem}
                          onClick={e => handleClick(e, menu)}
                        >
                          {Icon && <Icon className={classes.menuIcon} />}
                          <span className={classes.menuLabel}>{menu.title}</span>
                        </MenuItem>
                      );
                    })}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};

export default CollapsableButtonMenu;
